import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

// The server has no viewport, so it renders the desktop layout and the client
// switches to the real breakpoint right after hydration.
function getServerSnapshot() {
  return false;
}

/** Whether the viewport is narrower than `breakpoint` (768 px unless a caller needs its own cut). */
export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [breakpoint],
  );
  return React.useSyncExternalStore(
    subscribe,
    () => window.innerWidth < breakpoint,
    getServerSnapshot,
  );
}
